import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PublicMeta } from '../models/catalog.model';

@Injectable({
	providedIn: 'root'
})
export class CatalogMetaService {
	catalogMeta$: BehaviorSubject<Partial<PublicMeta>> = new BehaviorSubject<Partial<PublicMeta>>(null);
}
